// React Component
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// App Component
import { Routes } from '../routes'
import { Images } from '../constants'
import { useTheme } from '../contexts/ThemeContext'
import { useBranding } from '../contexts/BrandingContext'
import AuthBrandPanel from './AuthBrandPanel'
import './AuthLayout.css'

interface ChildProps {
    children: React.ReactNode
    /** Conservé pour compatibilité des appelants ; le panneau droit est toujours blanc. */
    rightPanelVariant?: 'default' | 'light'
}

const AuthLayout = (props: ChildProps) => {
    const { children } = props
    const { t } = useTranslation();

    const { theme } = useTheme();
    const { getLogo, isCustomBranding, branding } = useBranding();
    const customLogo = getLogo(theme);
    const displayLogo = customLogo || Images.logov1;
    const appName = isCustomBranding ? branding.appName : "Famla AI";

    const currentYear = new Date().getFullYear();

    return (
        <div id="authLayout">
            <div className="auth-page">
                <AuthBrandPanel logoSrc={displayLogo} appName={appName} />

                <div className="auth-form-panel">
                    <div className="auth-form-panel-inner">
                        <Link to={Routes.AUTH} className="auth-form-mobile-logo">
                            <img src={displayLogo} alt={appName} />
                        </Link>
                        {children}
                    </div>
                    <div className="auth-form-footer">
                        <div className="auth-layout-footer">
                            <a href={Routes.TERMS}>{t('navigation.termsAndConditions')}</a>
                            <span className="auth-layout-footer-sep">|</span>
                            <a href={Routes.PRIVACY}>{t('navigation.privacyPolicy')}</a>
                        </div>
                        <p className="auth-form-copyright mb-0">
                            Copyright © {currentYear} {appName}. {t('navigation.allRightsReserved')}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AuthLayout
